import React, { useEffect, useState } from "react";
import { Download, Mail } from "lucide-react";
import { api } from "@/lib/api";

export const NewsletterSection = () => {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/admin/newsletter").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  const download = () => {
    const csv = "email,data_iscrizione\n" + rows.map((r) => `${r.email},${r.createdAt.slice(0, 10)}`).join("\n");
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([csv], { type: "text/csv" }));
    a.download = "iscritti-newsletter.csv";
    a.click();
  };
  if (!rows) return <p className="text-sm text-slate-500">Caricamento…</p>;
  return (
    <div className="card-premium p-6" data-testid="admin-newsletter">
      <div className="flex items-center justify-between gap-3 mb-4">
        <h3 className="font-display text-xl font-bold flex items-center gap-2"><Mail className="w-5 h-5 text-gold"/>Iscritti newsletter <span data-testid="admin-newsletter-count" className="chip-gold">{rows.length}</span></h3>
        {rows.length > 0 && <button onClick={download} data-testid="admin-newsletter-csv" className="btn-pill-outline text-sm"><Download className="w-4 h-4"/>Scarica CSV</button>}
      </div>
      <p className="text-xs text-slate-500 mb-4">Email raccolte dal box nel footer. Per ora nessuna newsletter viene inviata.</p>
      {rows.length === 0 ? <p className="text-sm text-slate-500">Nessun iscritto.</p> : (
        <table className="w-full text-sm"><thead><tr className="text-left text-slate-500"><th className="py-2">Email</th><th>Data iscrizione</th></tr></thead>
          <tbody>{rows.map((r) => <tr key={r.id} className="border-t border-slate-100" data-testid="admin-newsletter-row"><td className="py-2">{r.email}</td><td>{new Date(r.createdAt).toLocaleDateString("it-IT")}</td></tr>)}</tbody>
        </table>
      )}
    </div>
  );
};
